import { ArrowBack, Login } from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { useCallback } from "react";
import { useQuery } from "react-query";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Table } from "../../../components/Table";
import { listBiDetail } from "../../../services/bi";
import { useStyles } from "../styles";

export function BiDetail() {
  const navigate = useNavigate();
  const styles = useStyles();
  const params = useParams();
  const location = useLocation();

  const details = useQuery(["biDetails", params.biId], () =>
    listBiDetail(params.biId)
  );

  const handleNavigateToDashboard = useCallback(
    (item: any) => {
      navigate(`${item.id_dashboard}`, { state: item });
    },
    [navigate]
  );

  const handleNavigateGoToBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  return (
    <>
      <div className={styles.root}>
        <Stack direction="row" spacing={1}>
          <Tooltip placement="top" title="Voltar">
            <IconButton onClick={handleNavigateGoToBack}>
              <ArrowBack />
            </IconButton>
          </Tooltip>
          <Typography variant="h4">{location.state["name"]}</Typography>
        </Stack>
      </div>
      <Paper className={styles.paper}>
        <Table
          toolbar={false}
          data={details.data as []}
          isLoading={details.isFetching}
          columns={[
            { title: "#ID", field: "id_submenu_filho" },
            { title: "Nome", field: "name" },
            {
              title: "Ações",
              align: "center",
              render: (row) => (
                <Tooltip title="Acessar" placement="top">
                  <IconButton onClick={() => handleNavigateToDashboard(row)}>
                    <Login />
                  </IconButton>
                </Tooltip>
              ),
            },
          ]}
          options={{
            actionsColumnIndex: -1,
            pageSize: 5,
            selectionProps: () => ({
              color: "primary",
            }),
          }}
        />
      </Paper>
    </>
  );
}
